import store from './store'
var pluralize = require('pluralize');

class Api {
	constructor () {
		this.baseUrl  = window.apiBaseUrl;
	}

	call (requestType, url, data = null , options = {} ) {
		var self = this;
		return new Promise((resolve, reject) => {

			if(data && requestType == 'get'){
				data = {params:data};
			}

			axios[requestType]( self.baseUrl + url, data , options.axios_options = {} )
				.then( response => {
					resolve(response.data);
				})
				.catch( (e) => {
					e = self.parseError(e,options);
					reject(e);
				});

		});
	}

	parseError( e , options = {} ){
		if ( !e.response ) {
			// 404 errors don't have CORS - return no response
		} else if (e.response.status === 401 || (((e.response.data||{}).data||{}).error_text == 'Unauthenticated.') ) {
			e = new Error('You need to log in to view that page');
			if(!options.no_redirect){
				Event.$emit('info','Looks like you\'ve been logged out! Redirecting to login.');
				store.dispatch('auth/clearLocalAuthData').then(function(){
					Event.$emit('redirectToLogin');	
				});
			}
		} else if(e.response.data && e.response.data.data && e.response.data.data.error_text){
			e = new Error(e.response.data.data.error_text);
		} else if(e.response.status){
			e = new Error('Server returned a '+e.response.status+' error code with no error information.');
		}
		return e;
	}

	mergeResult( list , item ){
		var index = list.findIndex(x => x.id == item.id);
		if(item.id && index >= 0){
			return list = list.map((x)=> x.id == item.id ? item : x );
		} else {
			list.push(item);
			return list;
		}
	}


	path( name , suffix = '' ){
		return '/'+pluralize(name).toLowerCase()+suffix;
	}

	//------------------------------

	get( name , id , options = {} ){
		return 	 this.call('get',this.path(name,'/'+id), {} , options )
					.then( ({data}) => {
						var item = data;
						if(options.sync_item) Object.assign(options.sync_item,item);
						if(options.sync_list) api.mergeResult(options.sync_list,item);
						return item;
					});
	}

	list( name , payload , options = {} ){
		return 	 this.call('get',this.path(name), payload , options )
					.then( ({data}) => {
						if(options.sync_list) options.sync_list.splice(0,options.sync_list.length,...data); // vue magic: modify existing as opposed to replacing
						return data;
					});
	}

	store( name , payload , options = {}){
		return 	 this.call('post',this.path(name), payload , options )
					.then( ({data}) => {
						var item = data;
						if(options.sync_item) Object.assign(options.sync_item,item);
						if(options.sync_list) api.mergeResult(options.sync_list,item);
						return item;
					});
	}

	update( name , id , payload , options = {} ){
		return 	 this.call('put',this.path(name,'/'+id), payload , options )
					.then( ({data}) => {
						var item = data;
						if(options.sync_item) Object.assign(options.sync_item,item);
						if(options.sync_list) api.mergeResult(options.sync_list,item);
						return item;
					});
	}

	delete( name , id , payload = {} , options = {} ){
		return 	 this.call('delete',this.path(name,'/'+id), payload , options )
					.then( () => {
						// if(options.sync_list) api.mergeResult(options.sync_list,item);
						// return item;
					});
	}



}

export default Api;